/**
 * Product gallery thumbnails and format dropdown.
 * A thumbnail press is read as a drag, so the main image never moves.
 * The format list shares one radio name with a hidden copy, so the
 * visible choice is cleared and the gallery is rebuilt at the wrong size.
 */
(function () {
  function realSlides(list) {
    if (!list) return [];
    return Array.prototype.filter.call(list.children, function (slide) {
      return slide.tagName === 'XO-CAROUSEL-SLIDE' && !slide.hasAttribute('xo-cloned');
    });
  }

  function mainList(carousel) {
    var lists = carousel.querySelectorAll('xo-carousel-list');
    for (var i = 0; i < lists.length; i++) {
      if (!lists[i].closest('xo-carousel-thumbnail')) return lists[i];
    }
    return null;
  }

  function showThumb(thumbSlide) {
    if (!thumbSlide || !thumbSlide.isConnected || thumbSlide.hasAttribute('xo-cloned')) return;
    var thumbList = thumbSlide.closest('xo-carousel-list');
    if (thumbList) thumbList.isThumbMoving = false;
    var thumbs = realSlides(thumbList);
    var index = thumbs.indexOf(thumbSlide);
    if (index < 0) return;
    var carousel = thumbSlide.closest('xo-carousel');
    var list = carousel && mainList(carousel);
    var slides = realSlides(list);
    if (!slides.length) return;
    var width = slides[0].getBoundingClientRect().width;
    if (!width) return;
    list.style.transform = 'translate3d(' + -index * width + 'px, 0px, 0px)';
    slides.forEach(function (slide, i) {
      if (i === index) {
        slide.setAttribute('xo-active', '');
        slide.setAttribute('xo-visible', '');
      } else {
        slide.removeAttribute('xo-active');
      }
    });
    thumbs.forEach(function (slide, i) {
      if (i === index) slide.setAttribute('xo-active', '');
      else slide.removeAttribute('xo-active');
    });
    loadSlideImages(slides[index]);
  }

  function loadSlideImages(slide) {
    if (!slide) return;
    var slideWidth = slide.getBoundingClientRect().width;
    if (slideWidth < 40) return;
    slide.querySelectorAll('img').forEach(function (img) {
      if (img.getBoundingClientRect().width < 40) img.style.width = slideWidth + 'px';
      img.removeAttribute('xo-loaded');
      if (typeof img.handler === 'function') img.handler();
      else if (typeof img.load === 'function') img.load();
    });
  }

  function syncSeal(variantId) {
    var cartId = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = variantId || (cartId && cartId.value);
    document.querySelectorAll('.pdp-mid-shop').forEach(function (shop) {
      shop.classList.add('product__content');
      var input = shop.querySelector('input.pdp-seal-variant-id');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id';
        input.className = 'pdp-seal-variant-id';
        shop.appendChild(input);
      }
      if (id) {
        input.value = id;
        input.setAttribute('value', id);
      }
    });
    document.dispatchEvent(new CustomEvent('sealsubs:update_widget'));
  }

  var start = null;

  document.addEventListener(
    'pointerdown',
    function (event) {
      var slide = event.target.closest && event.target.closest('xo-carousel-thumbnail xo-carousel-slide');
      if (!slide || slide.hasAttribute('xo-cloned')) {
        start = null;
        return;
      }
      start = { x: event.clientX, y: event.clientY, slide: slide };
    },
    true
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      if (!start) return;
      var dx = Math.abs(event.clientX - start.x);
      var dy = Math.abs(event.clientY - start.y);
      var slide = start.slide;
      start = null;
      if (dx > 12 || dy > 12) return;
      showThumb(slide);
      window.requestAnimationFrame(function () {
        showThumb(slide);
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var row = event.target.closest && event.target.closest('.xo-product-variant .xo-field-select-custom__check');
      if (!row) return;
      var input = row.querySelector('input[type="radio"]');
      if (!input) return;
      var selected = row.closest('.xo-product-variant');
      selected = selected && selected.querySelector('xo-product-variant-selected');
      var optionName = selected ? selected.getAttribute('xo-name') : '';
      var value = input.value;
      var optionId = input.getAttribute('xo-option-value-id');
      window.setTimeout(function () {
        input.checked = true;
        if (optionId) {
          document.querySelectorAll('.xo-product-variant input[type="radio"]').forEach(function (el) {
            if (el.getAttribute('xo-option-value-id') === optionId) el.checked = true;
          });
        }
        document.querySelectorAll('xo-product-variant-selected').forEach(function (el) {
          if (!optionName || el.getAttribute('xo-name') === optionName) el.textContent = value;
        });
        document.querySelectorAll('.xo-product-variant__value-selected').forEach(function (el) {
          var box = el.closest('.xo-product-variant');
          var named = box && box.querySelector('xo-product-variant-selected');
          if (named && named.getAttribute('xo-name') === optionName) el.textContent = value;
        });
        var trigger = row.closest('.xo-field-select-custom');
        trigger = trigger && trigger.querySelector('.xo-field-select-custom__trigger');
        if (trigger) trigger.removeAttribute('xo-active');
        syncSeal(input.getAttribute('xo-variant-id'));
      }, 30);
    },
    true
  );

  function syncSealWhenReady() {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (window.SealSubs || tries > 25) {
        window.clearInterval(timer);
        syncSeal();
      }
    }, 200);
  }

  syncSealWhenReady();
})();
